module.exports = __webpack_public_path__ + "media/add-ons/workshop@1x-9f77d872.png";